import React from "react";

export default function PageLoader() {
	return (
		<div className="full-page-loader">
			<div className="pulse-loader">
				<div className="pulse-ring"></div>
				<div className="pulse-ring"></div>
				<div className="pulse-ring"></div>
				<div className="pulse-core"></div>
			</div>
		</div>
	);
}
